/** Display fields of a currency, as the admin screen holds them. */
export interface CurrencyFormat {
  symbol: string;
  decimals: number;
  indianGrouping: boolean;
}

/** How the app writes [amount] in this currency, e.g. "S$1,250.00". */
export function previewAmount(c: CurrencyFormat, amount = 1250): string {
  const digits = amount.toLocaleString(c.indianGrouping ? 'en-IN' : 'en-US', {
    minimumFractionDigits: c.decimals,
    maximumFractionDigits: c.decimals,
  });
  return `${c.symbol}${digits}`;
}
